/**
 * Whether the notification bell should show attention (dot).
 * Personal inbox and Quackback news are independent channels.
 */
export function shouldShowNotificationAttention(
  personalUnread: number,
  newsUnread: number,
): boolean {
  return personalUnread > 0 || newsUnread > 0
}
